var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{attrs:{"color":"progressBar","height":"6","indeterminate":"","top":"","striped":"","active":_vm.active}})
}
var staticRenderFns = []

export { render, staticRenderFns }